import React from 'react';
import NextLink from 'next/link';
import classnames from 'classnames';
import { Icon, IconSize } from '@/components/common/Icon';
import { NavigationRoute } from '@/lib/navigationRoutes';
import { Colors } from '@/styles/colors';
import styles from './LeftNavigationPanel.module.scss';

interface ModuleRouteNavItemProps {
  item: NavigationRoute;
  isActive: boolean;
  onToggle: () => void;
}

export const ModuleRouteNavItem: React.FC<ModuleRouteNavItemProps> = ({ item, isActive, onToggle }) => {
  const hasSubRoutes = !!item.subRoutes?.length;

  const inner = (
    <>
      <span className={styles.moduleIconWrapper}>
        <Icon name={item.iconName} size={IconSize.s24} fillColor={isActive ? Colors.White : Colors.Neutral} />
      </span>
      <span className={styles.moduleLabel}>{item.label}</span>
    </>
  );

  const rowClassName = classnames(styles.moduleRow, {
    [styles.active]: isActive,
    [styles.disabled]: item.disabled,
  });

  if (hasSubRoutes) {
    return (
      <button type="button" className={rowClassName} onClick={item.disabled ? undefined : onToggle}>
        {inner}
      </button>
    );
  }

  return (
    <NextLink href={item.disabled ? '#' : item.href} className={rowClassName}>
      {inner}
    </NextLink>
  );
};
